import LocalizedStrings from "react-localization";

const strings = new LocalizedStrings({
    en: {
        //  Title
        fitnessAndProprietySystem: "Fitness and Propriety System",

        //  Navigation - page titles
        viewRequests: "View requests",
        searchPoi: "Search POI",
        searchContacts: "Search contacts",
        configureSystemDetails: "Configure system details",
        euSecLegBases: "EU sectoral legislative basis",
        reminder: "Reminder",
        periods: "Periods",
        poiSearchScenarios: "POI search scenarios",
        fieldGuidance: "Field guidance",
        manageSystemData: "Manage system data",
        poiList: "POI list",
        caContactList: "CA contact list",
        listOfFilesUploaded: "List of files uploaded",
        emailConfiguration: "Email configuration",
        caEndUserAssignment: "EU legal basis assignments",

        // Search Page
        requestForInfoButtonText: "Request for information",
        searchParameterLabel: "Search Parameter",
        advancedFieldsButtonText: "Advanced Fields",
        poiPlaceholder: "Type name",
        placeOfBirthCountryPlaceholder: "Type country",
        placeOfBirthCityPlaceholder: "Type city",
        searchCheckbox: "Exact match only",
        akaCheckbox: "Last name ~ AKA",
        idPlaceholder: "Type ID",
        numberPlaceholder: "Type number",
        selectCARecipientsLabel: "Select CA recipients",
        viewAssessmentsLabel: "View assessments",
        legalNameName: "legalName",
        leiRegistrationNumberLabel: "LEI / Registration number",
        leiRegistrationNumberName: "leiRegistration",
        countryOfIncorporationLabel: "Country of incorporation",
        countryOfIncorporationName: "countryInc",
        firstNameName: "firstName",
        lastNameName: "lastName",
        alsoKnownAsName: "alsoKnownAs",
        placeOfBirthLabel: "Place of birth",
        dateOfBirthName: "dateOfBirth",
        countryOfBirthName: "countryOfBirth",
        cityOfBirthName: "cityOfBirth",
        idName: "idNumber",
        idPlaceHolder: "Type ID",
        socialSecurityNumberName: "socialSecurityNumber",
        relevanceScoreLabel: "Relevance score",
        idTooltip: "When ID number is provided mandatory fields are altered.",
        ssnTooltip: "When Social security number is provided mandatory fields are altered.",
        akaTooltip: "When checkbox is selected, the system will search for the last name in the also known as POI attribute",
        // Email Configuration Page
        CAendUserSharedEmailName: "caEndUsersSharedEmail",
        CAdataManagerSharedEmailName: "caDataManagersSharedEmail",
        sharedEmailPlaceholder: "Type email address (or leave empty if no emails should be sent)",
        SharedEmailsSuccessfulUpdateMessage: "Changes have been saved successfully.",
        saveChangesButtonText: "Save changes",
        CAdataManagerErrorMessageDuplicate: "The CA Data Manager email address is already used by another NCA.",
        CAendUserSharedErrorMessageDuplicate: "The CA End User email address is already used by another NCA.",
        emailAddressAlreadyUsedMessage: "This email address is already used by another NCA.",
        emailAddressInvalidMessage: "Please include an '@' symbol and/or a valid domain extension.",
        noUsersAvailableForAssignment: "All users have been assigned to EU sectoral legislative bases.",

        // ListOfFilesUploaded labels
        listOfFilesUploadedLabel: "List of files uploaded",
        fileNameLabel: "Filename",
        actorLabel: "Actor",
        uploadDateTimeLabel: "Upload date/time",
        importMechanismLabel: "Import mechanism",
        uploadStatusLabel: "Upload status",
        numberOfImpactedIdsInCsvLabel: "Total records (pass/fail)",
        totalNumberOfFailedValidationRulesLabel: "Number of failed validation rules",
        validationLabel: "Validation",
        failedRulesLabel: "Failed rules",
        idLabel: "ID",
        countryOfBirthLabel: "Country of birth",
        leiRegistrationNoLabel: "LEI / Registration no.",
        countryIncLabel: "Country inc.",
        EUSecLegBasisLabel: "EU sectoral legislative basis",
        assessingCALabel: "Assessing CA internal ref. no",
        dateOfAssessmentLabel: "Date of assessment",
        submissionDateLabel: "Submission date",
        dateTimeUploadLabel: "Date and time of the upload",
        normalTabLabel: "Normal",
        historicalTabLabel: "Historical",

        //Bulk Delete assessments
        bulkDeleteAssessments: "Bulk deletion of assessments",
        bulkDeleteAssessmentsPageHeader: "Bulk deletion of assessments",
        bulkDeleteAssessmentsDialogHeader: "Delete records found",

        // ViewValidationResults labels
        fileDetails: "File details",

        // FilterPOIList
        addPoiLabel: "Add POI",
        bulkUploadLabel: "Bulk upload",
        bulkUploadOfDataLabel: "Bulk upload of data",
        downloadAllUploadedDataLabel: "Download all uploaded data",
        downloadAllUploadedDataDialogTitle: "Download all uploaded data",
        downloadAllUploadedDataDialogMessage: "This will download a CSV file containing all POI and assessment data uploaded by your organisation. Do you want to continue?",
        downloadAllUploadedDataCancelButton: "Cancel",
        downloadAllUploadedDataContinueButton: "Continue",
        downloadAllUploadedDataSuccess: "Uploaded data downloaded successfully.",
        downloadAllUploadedDataError: "Failed to download uploaded data.",
        downloadAllUploadedDataDownloading: "Downloading...",
        downloadAllUploadedDataCounting: "Counting records…",
        downloadAllUploadedDataRecordsLabel: "records will be included in this download.",
        downloadAllUploadedDataCountError: "The record count could not be determined. Please close this dialog and try again.",
        addPoiDetailsLabel: "Add POI details",

        // Assessment labels
        selectAndProceedText: "Select & proceed",

        // Email Configuration labels
        CAendUserSharedEmailLabel: "CA end users' shared email",
        CAdataManagerSharedEmailLabel: "CA data managers' shared email",

        //  Common labels
        datepickerPlaceholder: "dd/mm/yyyy",
        excelExportButtonText: "Export list",
        viewMetricsButtonText: "View metrics",
        viewHistoryButtonText: "View history",
        pdfExportButtonText: "Export request",
        viewMetricsActiveRequests: "Active requests",
        datePlaceholder: "Select a date",
        searchButtonText: "Search",
        resetButtonText: "Reset",
        spinnerLabel: "Loading...",
        noResultsText: "There are no results",
        closeButtonText: "Close",
        actionsLabel: "Actions",
        typeLabel: "Type",
        firstNameLabel: "First name",
        lastNameLabel: "Last name",
        dateOfBirthLabel: "Date of birth",
        cityOfBirthLabel: "City of birth",
        idNumberLabel: "ID number",
        socialSecurityNumberLabel: "Social security number",
        alsoKnownAsLabel: "Also known as",
        idNumber: "ID number",
        legalNameLabel: "Legal name",

        //  Pivot Labels
        activeTabLabel: "Active",
        outgoingTabLabel: "Outgoing",
        incomingTabLabel: "Incoming",
        draftTabLabel: "Draft",

        //  Filenames
        activeRequestsExport: "Active_Requests",
        outgoingRequestsExport: "Outgoing_Requests",
        incomingRequestsExport: "Incoming_Requests",
        draftRequestsExport: "Draft_Requests",
        validationResultsExport: "Validation_Results",

        // List of files uploaded page
        viewDetails: "View details",
        NA: "N/A",

        //  Request for Info Page
        requestForInfoNameLabel: "Name",
        requestForInfoAuthorityNameLabel: "CA name",
        requestForInfoUsernameLabel: "Username",
        requestForInfoAuthorityCountryLabel: "CA country",
        requestForInfoEmailLabel: "Email",
        requestForInfotab: "Request for information",
        requestForInfoInitiatorDetailsTitle: "Initiator details",
        requestForInfoPOITitle: "POI/Assessment details",
        requestForInfoPOIFirstName: "First name",
        requestForInfoPOILastName: "Last name",
        requestForInfoPOIPlaceOfBirth: "Place of birth",
        requestForInfoPOIDateOfBirth: "Date of birth",
        requestForInfoPOIAlsoKnownAs: "Also known as",
        requestForInfoIntAssessNo: "CA internal assessment number",
        requestForInfoPOIAssessDate: "Date of assessment",
        requestForInfoReqDetails: "Request details",
        requestForInfoRespDetails: "Response details",
        requestForInfoDisclaimer: "Disclaimer - Please do not disclose any personal or confidential assessment data in the request information",
        requestForInfoReasonForRequest: "Reason for request",
        requestForInfoInfoRequested: "Requested information",
        requestForInfoEUSecLegBasis: "EU sectoral legislative basis",
        requestForInfoResponseType: "Response type",
        requestForInfoResponseDateUntil: "Until",
        requestForInfoResponseComments: "Comments",
        requestForInfoPDFButton: "PDF",
        requestForInfoEditButton: "Edit recipients",
        requestForInfoCopyButton: "Copy details to all recipients",
        requestForInfoSaveDraftButton: "Save as draft",
        requestForInfoSubmitResponseButton: "Submit response",
        requestForInfoSubmitButton: "Submit",
        requestForInfoDatePickerAriaLabel: "Select date",
        requestForInfoDropDownPlaceholder: "Select response",
        newResponseSubmitSuccess: "Your response has been submitted",
        requestForInfoSubmitResponded: "You are about to respond to the request for information. Are you sure you want to continue?",
        requestForInfoSubmitPartial: "You are about to partially respond to the request for information. Are you sure you want to continue?",
        requestForInfoSubmitImpossible: "You are about to declare the request for information as impossible to respond to. Are you sure you want to continue?",
        requestForInfoSubmitPostpone: "You are about to postpone your response to the request for information. Are you sure you want to continue?",

        //  New Request for Info Page
        newRequestForInfoPivot: "New request for information",
        newRequestForInfoInitDetails: "Initiator details",
        newRequestForInfoRecipientsDetails: "Recipients and request details",
        newRequestForInfoDisclaimer: "Disclaimer: Please do not disclose personal data",
        newRequestForInfoFieldIsRequired: "Field is required",
        newRequestForInfoInitDetailsName: "Name",
        newRequestForInfoInitDetailsUsername: "Username",
        newRequestForInfoInitDetailsEmail: "Email",
        newRequestForInfoInitDetailsAuthName: "Authority Name",
        newRequestForInfoInitDetailsAuthCountry: "Authority Country",
        newRequestForInfoPoiTitle: "POI details",
        newRequestForInfoPOILabel: "Person of Interest",
        newRequestForInfoPOICA: "CA internal Assessment No.",
        newRequestForInfoPOIFName: "First name",
        newRequestForInfoPOILName: "Last name",
        newRequestForInfoPOIAKA: "Also known as",
        newRequestForInfoPOIBirthPlace: "Place of birth",
        newRequestForInfoPOIBirthDate: "Date of birth",
        newRequestForInfoRequestDetailsLabel: "Request details",
        newRequestForInfoRequestDetailsNumber: "Request number",
        newRequestForInfoRequestDetailsReason: "Reason for request",
        newRequestForInfoRequestDetailsInfo: "Requested information",
        newRequestForInfoRequestDetailsBasis: "EU sectoral legislative basis",
        newRequestForInfoRequestDetailsComment: "Comment",
        newRequestForInfoRequestDetailsPostponeDate: "Postpone Date",
        newRequestForInfoPDFButton: "PDF",
        newRequestForInfoConfirmButton: "Confirm",
        newRequestForInfoUnauthorised: "You are not authorised to create a new request",
        newRequestErrorNoNcaSelected: "You have not selected any NCAs to send the request to",
        newRequestDraftSuccess: "The request is saved as draft successfully",
        newRequestSubmitSuccess: "The request is submitted successfully",

        //Search Contacts
        searchContactsFirstName: "First name",
        searchContactsLastName: "Last name",
        searchContactsCountry: "Country",
        searchContactsAuthority: "Authority",
        searchContactsLegalFrameworkDepartment: "Legal framework - department",
        searchContactsSearchButton: "Search",
        searchContactsResetButton: "Reset",
        searchContactsSelectKey: "select",
        searchContactsTypeFirstNamePlaceholder: "Type first name",
        searchContactsTypeLastNamePlaceholder: "Type last name",
        searchContactsTypeLegalFrameworkDepartmentPlaceholder: "Type legal framework - department",
        searchContactsSwitchCaseCountry: "country",
        searchContactsSwitchCaseAuthority: "authority",
        searchContactsSelectCountry: "Select country",
        searchContactsSelectAuthority: "Select authority",
        searchContactsTextFieldFirstName: "firstName",
        searchContactsTextFieldLastName: "lastName",
        searchContactsTextFieldLegalFrameworkDepartment: "legalFrameworkDepartment",
        searchContactsEventKeyEnter: "Enter",
        searchContactsErrorFetchingCountries: "Error fetching country options:",
        searchContactsErrorFetchingAuthorities: "Error fetching authority options:",
        searchContactsNoContactsFound: "No contacts are found",

        //  View Requests - Column Names
        columnNameOutgoing: "",
        columnNameRequestNo: "Request no.",
        columnNameCA: "CA internal assessment no.",
        columnNameAuthority: "Authority",
        columnNameRequestedAuthority: "Requested authority",
        columnNameRequestingAuthority: "Requesting authority",
        columnNameBasis: "EU sec. leg. basis",
        columnNameType: "Type",
        columnNamePOI: "Person of interest",
        columnNameSubmissionDate: "Submission date",
        columnNameExpectedDate: "Expected comp. date",
        columnNameClosingDate: "Date of closure",
        columnNameCreationDate: "Creation date",
        columnNameStatus: "Status",
        columnNameRemaining: "Remaining days",
        columnNameActions: "Actions",

        //  View Requests - Status Names
        statusDraft: "DRAFT",
        statusSubmitted: "SUBMITTED",
        statusInProgress: "IN PROGRESS",
        statusPostpone: "REQUEST POSTPONED",
        statusImpossible: "IMPOSSIBLE TO RESPOND",
        statusPartially: "PARTIALLY RESPONDED",
        statusResponded: "RESPONDED",
        statusClosed: "SYSTEM CLOSED",
        statusCancelled: "CANCELLED",

        // View Requests - Filters
        filterLabelRequestNo: "Request no.",
        filterPlaceholderRequestNo: "Type number",
        filterLabelRequestingAuthority: "Requesting authority",
        filterLabelRequestedAuthority: "Requested authority",
        filterPlaceholderRequestAuthority: "Select authority",
        filterLabelEuSecLegBasis: "EU sectoral legislative basis",
        filterPlaceholderEuSecLegBasis: "Select basis",
        filterLabelStatus: "Status",
        filterPlaceholderStatus: "Select status",
        filterLabelSubmissionDate: "Submission date",
        filterLabelCreationDate: "Creation date",
        filterPlaceholderDateFrom: "From dd/mm/yyyy",
        filterPlaceholderDateTo: "To dd/mm/yyyy",
        filterLabelInitiatorCheckbox: "I am the initiator",
        filterLabelType: "Type",
        filterPlaceholderType: "Select type",
        filterButtonFilter: "Filter",
        filterButtonReset: "Reset",

        //View Requests - Actions
        requestActionView: "View request",
        requestActionSendReminder: "Send reminder",
        requestActionCancel: "Cancel request",
        requestActionDelete: "Delete request",

        //View Requests - Modals
        requestModalSendReminderTitle: "Send a reminder to requested CA",
        requestModalSendReminderReqNoTitle: "Request no",
        requestModalSendReminderBody: "Upon confirmation a kind reminder will be sent by email to the requested CA.",
        requestModalSendReminderBody2: "Please confirm to proceed.",
        requestModalCancelTitle: "",
        requestModalCancelBody: "Upon confirmation the request will be assigned with status “Cancelled”. This status is non-reversible. Please provide the reason for cancellation to proceed.",
        requestModalJustificationLabel: "Justification",
        requestModalDeleteDraftTitle: "Delete draft request",
        requestModalDeleteDraftBody: "The draft request is about to be deleted. This action is non-reversible. Are you sure you want to continue?",
        requestModalButtonConfirm: "Confirm",
        requestModalButtonCancel: "Cancel",

        requestResultLoading: "Waiting for results",
        requestNoResults: "No results were found.",
        requestNoResultsFiltered: "No matching results were found. Please refine your filtering criteria.",


        //  MessageBar
        messageBarCancelSuccess: "The request is cancelled successfully",
        messageBarCancelError: "An error occurred while cancelling the request",
        messageBarReminderSuccess: "An email reminder is sent successfully to the requested CA.",
        messageBarReminderError: "An error occurred while sending the email reminder",
        messageBarDeleteDraftSuccess: "The draft request is deleted successfully",
        messageBarDeleteDraftError: "An error occurred while deleting the draft request",
        messageBarExportListSpinner: "The system is generating the file",
        messageBarExportListSuccess: "The file was exported successfully",
        messageBarExportListError: "An error occurred while generating the file",
        messageBarValidationError: "Not all mandatory fields are provided for NCAs ###. Please fill in the necessary information",
        messageBarValidationErrorView: "Not all mandatory fields are provided. Please fill in the necessary information",
        messageBarUnauthorizedNCA: "Failed to fetch CSV details. Error: You are not authorized to access another NCA’s data",
        messageBarBulkDeleteAssessmentsNoAssessmentsFound: "No assessments were found to delete within the selected dates.",
        messageBarBulkDeleteAssessmentsSuccess: "The request for deleting all your NCA's assessments in the given timeframe has been accepted. You will be notified via email once the process has been completed.",
        messageBarBulkDeleteAssessmentsSelectBothDates: "Please enter both dates",
        messageBarBulkDeleteAssessmentsFromDateAfterToDate: "The \"from\" date cannot exceed  the \"to\" date",


        //  Admin - euslb
        euSLBLabel: "EU sectoral legislative basis",
        admineditbtntest: "Save Changes",
        euSLBNameExistsError: "Error the Name already exists.",
        euSLBUnexpectedError: "An unexpected error occurred.",

        //Admin Periods Labels
        PeriodsAnswer: "Answer period",
        PeriodsEscalation: "Escalation (reminder) period",
        PeriodsRetention: "Retention period",
        PeriodsRecycle: "Recycle bin period",
        ButtonSave: "Save Changes",

        //Admin Field Guidance Labels
        FieldGuidanceReasonForRequest: "Reason for request",
        FieldGuidanceInfoRequested: "Requested information",

        //  Feeding Data - POI List
        POIListLabel: "Person of interest",
        POIListIDNumber: "ID number",
        POIListSocialSecurityNumber: "Social security number",
        POIListBulkUploadLabel: "Bulk Upload of Assessment Data",
        POIListExcelFileLabel: "Excel File",
        POIListExcelFilePlaceholder: "Please click here to select a file",
        POIListImportHistButtonText: "Import Historical Data",
        POIListImportButtonText: "Import Data",
        POIListTemplateFileLabel: "Please use this file as a template",
        POIListTemplatesFileLink: "CSV templates",
        POIListTemplateFileLink: "CSV template",
        POIListFileLabel: "Choose file",
        POIListFileHistLabel: "Choose file with historical data",
        POIListAssessmentIntAssessNo: "CA internal assessing number",
        POIDefaultErrorMessage: "An error occurred while processing the request",

        addSearchScenarioButtonText: "Add search scenario",

        // Search scenarios - Column Names
        columnNameID: "ID",
        columnNameFirstName: "First name",
        columnNameLastName: "Last name",
        columnNameLegalName: "Legal name",
        columnNameAKA: "Also known as",
        columnNameDOB: "Date of birth",
        columnNamePOB: "Place of birth",
        columnNameIDNumber: "ID number",
        columnNameLeiRegistration: "LEI / Registration number",
        columnNameCountryInc: "Country of incorporation",
        columnNameSSN: "Social security number",

        messageBarScenarioInsertSuccess: "The scenario is added successfully in the system",
        messageBarScenarioUpdateSuccess: "The search scenario is edited successfully",
        messageBarDeleteScenarioSuccess: "The search scenario is deleted successfully",
        messageBarScenarioExistsError: "The search scenario already exists in the system",
        messageBarInvalidScenarioError: "Invalid scenario",
        messageBarInternalServerError: "An error occurred",
        messageBarDeleteScenarioError: "An error occurred while deleting the scenario",

        //  Footer
        footerCopyright: "© 2023 Fitness and Propriety System",

        // Assessment List
        addNewAssessmentSelectDate: "Date of assessment",
        addNewAssessmentSuccessMessage: "The assessment is added successfully in the system.",
        addNewAssessmentErrorMessage: "Error the assessment already exists.",
        addNewAssessmentExistsMessage: "The assessment you are trying to create, already exists in the system.",
        updateNewAssessmentSuccessMessage: "The assessment is updated successfully.",
        updateNewAssessmentErrorMessage: "Error the assessment coundn\'t be update.",
        updateNewAssessmentExistMessage: "The edited assessment already exists in the system",
        deleteNewAssessmentSuccessMessage: "The assessment is deleted successfully from the system.",
        deleteNewAssessmentErrorMessage: "The assessment cannot be deleted because there is an active request associated with this assessment",
        assessmentDefaultErrorMessage: "An error occurred while processing the request",

        // Contact List
        teamNameLabel: "Team name",
        phoneLabel: "Professional tel. no.",
        legalFrameworkDepartment: "Legal framework - department",
        positionLabel: "Position",
        addNewContactSuccessMessage: "The CA contact has been added successfully.",
        addNewContactErrorMessage: "Error the contact already exists.",
        addNewContactExistsMessage: "The contact you are trying to create, already exists in the system.",
        updateNewContactSuccessMessage: "The contact is updated successfully.",
        updateNewContactErrorMessage: "Error the contact could not be update.",
        updateNewContactExistMessage: "The edited Contact already exists in the system",
        deleteNewContactSuccessMessage: "The Contact has been deleted successfully.",
        deleteNewContactErrorMessage: "The Contact cannot be deleted",

        //  Unauthorized page
        unauthorizedAccess: "Unauthorized Access",
        noPermission: "You do not have permission to access this page.",
        pageNotFound: "Page not found",
        pageNotFoundText: "The page you are looking for does not exist.",
    }
});

export default strings;
